export const MYTRIPS_LOGIN_GA_TRACKING_PREFIX = "cat:mytrips";
